import { Link } from "react-router-dom";
import type { AnimeItem } from "@/mocks/animeData";

interface AnimeCardProps {
  anime: AnimeItem;
  size?: "sm" | "md" | "lg";
}

export default function AnimeCard({ anime, size = "md" }: AnimeCardProps) {
  const sizeClasses = {
    sm: "w-full",
    md: "w-full",
    lg: "w-full",
  };

  const imgHeight = {
    sm: "h-48",
    md: "h-64",
    lg: "h-80",
  };

  return (
    <Link
      to={`/article/${anime.id}`}
      className={`${sizeClasses[size]} group block cursor-pointer`}
    >
      <div
        className={`${imgHeight[size]} relative overflow-hidden rounded-lg mb-3`}
      >
        <img
          src={anime.coverImage}
          alt={`${anime.title} - 风车动漫在线观看`}
          title={`${anime.title} - 风车动漫在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute top-2 right-2 bg-primary-500 text-background-950 text-xs font-bold px-2 py-0.5 rounded-md whitespace-nowrap">
          {anime.rating}
        </div>
        {anime.status === "已完结" && (
          <div className="absolute top-2 left-2 bg-background-950/80 text-foreground-300 text-xs px-2 py-0.5 rounded-md whitespace-nowrap">
            {anime.status}
          </div>
        )}
        <div className="absolute bottom-2 left-2 right-2 flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="text-xs text-foreground-200 bg-background-950/70 px-2 py-1 rounded-md whitespace-nowrap">
            {anime.episodes}
          </span>
          <span className="text-xs text-foreground-200 bg-background-950/70 px-2 py-1 rounded-md whitespace-nowrap">
            {anime.year}
          </span>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors line-clamp-1">
        {anime.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1">{anime.category}</p>
    </Link>
  );
}